import React from 'react';

function HTMLEntity({ code, ...rest }) {
  return <span {...rest} dangerouslySetInnerHTML={{ __html: code }} />;
}

export default HTMLEntity;
